/* ### CONSTANTS ### */

import { IQueryMetaDataType } from '../../../../../boilerplate/redux/types/IQueryMetaDataType';
import { IApiErrorType } from '../../../../types/BaseTypes';
import { IVendorWidgetType } from '../../types/IVendorWidgetType';

export const VENDOR_WIDGET_FETCH_ENTRIES = '@BasePipeline/vendorWidgetReducer_FETCH_ENTRIES';
export const VENDOR_WIDGET_FETCH_ENTRY   = '@BasePipeline/vendorWidgetReducer_FETCH_ENTRY';
export const VENDOR_WIDGET_ADD_ENTRIES = '@BasePipeline/vendorWidgetReducer_ADD_ENTRIES';
export const VENDOR_WIDGET_ADD_ENTRY = '@BasePipeline/vendorWidgetReducer_ADD_ENTRY';

export const VENDOR_WIDGET_SET_ERRORS   = '@BasePipeline/vendorWidgetReducer_SET_ERRORS';

/* ### ACTIONS ### */

export function fetchVendorWidgets (queryKey: string) {
	return {
		type: VENDOR_WIDGET_FETCH_ENTRIES,
		queryKey,
	};
}

export function addVendorWidgetEntries (queryKey: string, entries: IVendorWidgetType[], metaData?: IQueryMetaDataType , options?: IFetchOptionType) {
	return {
		type: VENDOR_WIDGET_ADD_ENTRIES,
		queryKey,
		entries,
		metaData,
		options
	};
}

export function addVendorWidgetEntry (queryKey: string, entry: IVendorWidgetType, metaData?: IQueryMetaDataType , options?: IFetchOptionType) {
	return {
		type: VENDOR_WIDGET_ADD_ENTRY,
		queryKey,
		entry,
		metaData,
	};
}

export function setVendorWidgetErrors (queryKey: string, errors: IApiErrorType[], metaData?: IQueryMetaDataType , options?: IFetchOptionType) {
	return {
		type: VENDOR_WIDGET_SET_ERRORS,
		queryKey,
		errors,
		metaData,
	};
}
